import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { useDroppable } from '@dnd-kit/core'

export const DroppableCategory = ({
    children,
    disabled = false,
    category,
    categoryIndex,
    onIncorrect,
    id,
}) => {
    const {setNodeRef} = useDroppable({
        id,
        disabled,
    })

    const [lastChildCount, setLastChildCount] = useState(0)
    const [lastPlacedIsCorrect, setLastPlacedIsCorrect] = useState(false)
    const [flash, setFlash] = useState(false)

    useEffect(() => {
        if (lastChildCount < children.length) {
            const isCorrect = children[children.length - 1]?.props?.image.parentCategoryIndex === categoryIndex

            setLastChildCount(children.length)
            setLastPlacedIsCorrect(isCorrect)
            setFlash(true)
            setTimeout(() => {
                setFlash(false)

                if (!isCorrect) onIncorrect(children.at(-1).props.image)
            }, isCorrect ? 500 : 1000)
        } else {
            setLastChildCount(children.length)
        }
    }, [children.length])

    return (
        <div
            className={classNames(`relative p-2 ease-out duration-700`, {
                'transition-none': flash,
                'transition-colors': !flash,
                'bg-lightGreen': flash && lastPlacedIsCorrect,
                'bg-lightRed': flash && !lastPlacedIsCorrect,
                'bg-white': !flash,
            })}
            ref={setNodeRef}
        >
            {children}
        </div>
    )
}
